import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUserPermissions } from '../services/security-groups';
import type { UpdateUserPermissionsPayload } from '../types/security-admin.types';

export function useUpdateUserPermissionsMutation(groupId: string, invalidationUserId?: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: UpdateUserPermissionsPayload }) =>
      updateUserPermissions(groupId, userId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'users'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      if (invalidationUserId) {
        queryClient.invalidateQueries({ queryKey: ['security', 'users', invalidationUserId, 'groups'] });
      }
    },
  });
}
